const i = {
  name: "BinFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.2815 4L15.8506 2.26925C15.5186 0.927611 14.3138 0 12.94 0H11.06C9.6863 0 8.48151 0.927556 8.14945 2.26914L7.71847 4H2V6H3.55431L4.4016 21.1665C4.4916 22.7565 5.81021 24 7.4 24H16.62C18.2098 24 19.5284 22.7558 19.6184 21.1658L20.4657 6H22V4H16.2815ZM11.06 2H12.94C13.406 2 13.801 2.31203 13.9092 2.74997L14.2205 4H9.77954L10.0904 2.75162L10.0908 2.74997C10.199 2.31203 10.594 2 11.06 2ZM10.5 9V19H8.5V9H10.5ZM15.5 19H13.5V9H15.5V19Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as BinFilled
};
